// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import DealerSearchParams, {getDefaultState as getDealerSearchParamsDefaultState} from './dealer-search-params';
import Dealers, {getDefaultState as getDealersDefaultState} from '../../shared/state/dealers';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    dealers: Dealers,
    hasSearchRun: t.Boolean,
    searchParams: DealerSearchParams
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        dealers: getDealersDefaultState(),
        hasSearchRun: false,
        searchParams: getDealerSearchParamsDefaultState()
    });

export default State;




// WEBPACK FOOTER //
// ./src/product/dealer-search/state/index.js